/**
 * MCP MetaInfo-Declare Approval Store
 *
 * Holds the one pending `metainfo_declare` approval request from an AI agent.
 * Sibling of `connectionsAddApprovalStore` — same shape, different channel.
 */

import { create } from 'zustand';
import type { McpMetaInfoDeclareApprovalRequest } from '../../../types/mcpUiControl';

type MetaInfoDeclareApprovalState = {
  /** Currently pending declaration approval request */
  pendingRequest: McpMetaInfoDeclareApprovalRequest | null;
  setPendingRequest: (request: McpMetaInfoDeclareApprovalRequest | null) => void;
  approveRequest: (requestId: string) => void;
  denyRequest: (requestId: string) => void;
};

export const useMetaInfoDeclareApprovalStore = create<MetaInfoDeclareApprovalState>(
  (set, get) => ({
    pendingRequest: null,

    setPendingRequest: (request) => {
      set({ pendingRequest: request });
    },

    approveRequest: (requestId) => {
      const { pendingRequest } = get();
      if (pendingRequest && pendingRequest.requestId === requestId) {
        window.electronAPI?.mcpUiControl?.sendMetaInfoDeclareApprovalResponse(requestId, true);
        window.electronAPI?.analytics
          ?.track('ui:mcp_metainfo_declare_approved', { kind: pendingRequest.kind })
          .catch(() => {});
        set({ pendingRequest: null });
      }
    },

    denyRequest: (requestId) => {
      const { pendingRequest } = get();
      if (pendingRequest && pendingRequest.requestId === requestId) {
        window.electronAPI?.mcpUiControl?.sendMetaInfoDeclareApprovalResponse(requestId, false);
        window.electronAPI?.analytics
          ?.track('ui:mcp_metainfo_declare_denied', { kind: pendingRequest.kind })
          .catch(() => {});
        set({ pendingRequest: null });
      }
    },
  }),
);
